import corrosive from './corrosive.png';
import irritant from './irritant.png';
import inhalationSensitizer from './inhalationSensitizer.png';
import oxidising from './oxidising.png';
import flammable from './flammable.png';
import environment from './environment.png';

export default { corrosive, irritant, inhalationSensitizer, flammable, oxidising, environment };
